import React from 'react';
import {
  CalendarPlus, Gift, UserCheck, X, Eye,
} from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../ui/dialog';
import { Textarea } from '../../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const UserSubscriptionModal = ({ ctx }) => {
  const { showUserModal, setShowUserModal, selectedUser, subscriptionAction, setSubscriptionAction, subscriptionDays, setSubscriptionDays, subscriptionReason, setSubscriptionReason, actionLoading, handleSubscriptionAction } = ctx;
  return (
          <Dialog open={showUserModal} onOpenChange={setShowUserModal}>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle>Abonnement Beheren</DialogTitle>
                <DialogDescription>
                  {selectedUser?.name} ({selectedUser?.email})
                </DialogDescription>
              </DialogHeader>
              
              <div className="space-y-4 py-4">
                {/* Current Status */}
                {selectedUser?.subscription && (
                  <div className="p-3 rounded-lg bg-muted/50">
                    <p className="text-sm font-medium">Huidige status</p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className={`text-xs px-2 py-0.5 rounded-full ${
                        selectedUser.subscription.status === 'active' ? 'bg-green-100 text-green-700' :
                        selectedUser.subscription.status === 'trial' ? 'bg-blue-100 text-blue-700' :
                        'bg-gray-100 text-gray-600'
                      }`}>
                        {selectedUser.subscription.status === 'active' ? 'Premium' :
                         selectedUser.subscription.status === 'trial' ? 'Trial' : 
                         selectedUser.subscription.status}
                      </span>
                      {selectedUser.subscription.subscription_end_date && (
                        <span className="text-xs text-muted-foreground">
                          tot {new Date(selectedUser.subscription.subscription_end_date).toLocaleDateString('nl-NL')}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                <div className="space-y-2">
                  <Label>Actie</Label>
                  <Select value={subscriptionAction} onValueChange={setSubscriptionAction}>
                    <SelectTrigger data-testid="subscription-action-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="extend">
                        <div className="flex items-center gap-2">
                          <CalendarPlus className="w-4 h-4" />
                          Abonnement verlengen
                        </div>
                      </SelectItem>
                      <SelectItem value="grant_free">
                        <div className="flex items-center gap-2">
                          <Gift className="w-4 h-4" />
                          Gratis premium geven
                        </div>
                      </SelectItem>
                      <SelectItem value="activate">
                        <div className="flex items-center gap-2">
                          <UserCheck className="w-4 h-4" />
                          Abonnement activeren
                        </div>
                      </SelectItem>
                      <SelectItem value="cancel">
                        <div className="flex items-center gap-2">
                          <X className="w-4 h-4" />
                          Abonnement annuleren
                        </div>
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                {(subscriptionAction === 'extend' || subscriptionAction === 'grant_free') && (
                  <div className="space-y-2">
                    <Label htmlFor="days">Aantal dagen</Label>
                    <Input
                      id="days"
                      data-testid="subscription-days-input"
                      type="number"
                      min={1}
                      max={365}
                      value={subscriptionDays}
                      onChange={e => setSubscriptionDays(parseInt(e.target.value) || 30)}
                    />
                  </div>
                )}

                <div className="space-y-2">
                  <Label htmlFor="reason">Reden (optioneel)</Label>
                  <Textarea
                    id="reason"
                    data-testid="subscription-reason-input"
                    placeholder="bijv. VIP klant, tester, klacht opgelost..."
                    value={subscriptionReason}
                    onChange={e => setSubscriptionReason(e.target.value)}
                    rows={2}
                  />
                </div>
              </div>

              <DialogFooter>
                <Button variant="outline" onClick={() => setShowUserModal(false)}>
                  Annuleren
                </Button>
                <Button
                  data-testid="save-subscription-btn"
                  onClick={handleSubscriptionAction}
                  disabled={actionLoading}
                  className={subscriptionAction === 'cancel' ? 'bg-destructive hover:bg-destructive/90' : 'bg-gold hover:bg-gold/90 text-night-blue'}
                >
                  {actionLoading ? 'Bezig...' : 'Opslaan'}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
  );
};
